
export const COLOR_BASE = '#196770';
export const COLOR_ACCENT = '#EBB451';
export const COLOR_DARK = '#312336';
export const COLOR_WHITE = '#F7F4F4';
